import { Navigate } from "react-router-dom";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

// decode jwt payload safely
function decodeJWT(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

function isExpired(token) {
  const payload = decodeJWT(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000;
}

const RequireAuth = ({ children }) => {
  const access = localStorage.getItem(ACCESS_TOKEN_KEY);
  const refresh = localStorage.getItem(REFRESH_TOKEN_KEY);

  if (!access || !refresh) {
    return <Navigate to="/login" replace />;
  }

  if (isExpired(access)) {

    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;
